import { useEffect, useRef, useState } from 'react';

// Scrollable category tab bar with left/right chevron buttons. The active
// tab auto-scrolls into view when it changes.

export default function TabBar({ categories, active, onSelect }) {
  const scrollerRef = useRef(null);
  const [canL, setCanL] = useState(false);
  const [canR, setCanR] = useState(false);

  const refresh = () => {
    const el = scrollerRef.current;
    if (!el) return;
    setCanL(el.scrollLeft > 1);
    setCanR(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
  };

  useEffect(() => { refresh(); }, [categories]);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    const t = setTimeout(() => {
      const activeEl = el.querySelector('.ss-tab.active');
      if (activeEl) {
        try { activeEl.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch { /* noop */ }
      }
      refresh();
    }, 30);
    return () => clearTimeout(t);
  }, [active]);

  return (
    <div className="ss-catbar-wrap">
      <button
        type="button"
        className="ss-cat-nav ss-cat-prev"
        aria-label="Scroll left"
        disabled={!canL}
        onClick={() => scrollerRef.current && scrollerRef.current.scrollBy({ left: -280, behavior: 'smooth' })}
      >‹</button>
      <nav className="ss-catbar" ref={scrollerRef} onScroll={refresh}>
        {categories.map(c => (
          <button
            key={c.id}
            type="button"
            className={'ss-tab' + (c.id === active ? ' active' : '')}
            onClick={() => onSelect(c.id)}
          >
            <span className="ss-cat-dot" />
            {c.label}
          </button>
        ))}
      </nav>
      <button
        type="button"
        className="ss-cat-nav ss-cat-next"
        aria-label="Scroll right"
        disabled={!canR}
        onClick={() => scrollerRef.current && scrollerRef.current.scrollBy({ left: 280, behavior: 'smooth' })}
      >›</button>
    </div>
  );
}
